import { render, staticRenderFns } from "./traMedici.vue?vue&type=template&id=421778f6&scoped=true"
import script from "./traMedici.vue?vue&type=script&lang=js"
export * from "./traMedici.vue?vue&type=script&lang=js"
import style0 from "./traMedici.vue?vue&type=style&index=0&id=421778f6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "421778f6",
  null
  
)

export default component.exports